import { render, staticRenderFns } from "./HealthEquitySection.vue?vue&type=template&id=013d426b&scoped=true&"
import script from "./HealthEquitySection.vue?vue&type=script&lang=js&"
export * from "./HealthEquitySection.vue?vue&type=script&lang=js&"
import style0 from "./HealthEquitySection.vue?vue&type=style&index=0&id=013d426b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013d426b",
  null
  
)

export default component.exports